import React, { useState } from 'react';
import BaseModal from '../common/BaseModal';

function AcceptRequestModal({ isOpen, onClose, onAccept }) {
    const [definitiveArrivalTime, setDefinitiveArrivalTime] = useState('');
    const [startTimeSlot, setStartTimeSlot] = useState('');
    const [endTimeSlot, setEndTimeSlot] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        // Call the confirm callback with the time values
        onAccept({
            definitiveArrivalTime,
            startTimeSlot,
            endTimeSlot
        });

        // Reset form
        setDefinitiveArrivalTime('');
        setStartTimeSlot('');
        setEndTimeSlot('');
        setError('');
    };

    const handleClose = () => {
        // Reset form when closing
        setDefinitiveArrivalTime('');
        setStartTimeSlot('');
        setEndTimeSlot('');
        setError('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <BaseModal
            show={isOpen}
            onClose={handleClose}
            title="Aanvraag accepteren"
            footer={
                <>
                    <button
                        type="submit"
                        form="accept-request-form"
                        className="min-w-40 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors h-9"
                    >
                        Accepteren
                    </button>
                    <button
                        type="button"
                        onClick={handleClose}
                        className="min-w-40 px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition-colors h-9"
                    >
                        Annuleren
                    </button>
                </>
            }
        >
            <p className="text-gray-600">
                Weet je zeker dat je deze aanvraag wilt accepteren? Vul het definitieve aankomsttijd alleen in als je zeker weet dat het tijdstip definitie is. Vul anders de aankomsttijdsslots in.
            </p>

            {error && (
                <div className="p-3 bg-red-100 text-red-700 rounded">
                    {error}
                </div>
            )}

            <form id="accept-request-form" onSubmit={handleSubmit}>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Definitieve aankomsttijd
                        </label>
                        <input
                            type="time"
                            value={definitiveArrivalTime}
                            onChange={(e) => setDefinitiveArrivalTime(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Begin aankomsttijdsslot
                        </label>
                        <input
                            type="time"
                            value={startTimeSlot}
                            onChange={(e) => setStartTimeSlot(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Einde aankomsttijdsslot
                        </label>
                        <input
                            type="time"
                            value={endTimeSlot}
                            onChange={(e) => setEndTimeSlot(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                </div>
            </form>
        </BaseModal>
    );
}

export default AcceptRequestModal;
